/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalExchangeRequest
 */
export interface PortalExchangeRequest {
    /**
     * 
     */
    token: string;
    /**
     * Calendar date, YYYY-MM-DD
     */
    date_of_birth: string;
}

/**
 * Check if a given object implements the PortalExchangeRequest interface.
 */
export function instanceOfPortalExchangeRequest(value: object): value is PortalExchangeRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('date_of_birth' in value) || value['date_of_birth'] === undefined) return false;
    return true;
}

export function PortalExchangeRequestFromJSON(json: any): PortalExchangeRequest {
    return PortalExchangeRequestFromJSONTyped(json, false);
}

export function PortalExchangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalExchangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'date_of_birth': json['date_of_birth'],
    };
}

export function PortalExchangeRequestToJSON(json: any): PortalExchangeRequest {
    return PortalExchangeRequestToJSONTyped(json, false);
}

export function PortalExchangeRequestToJSONTyped(value?: PortalExchangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'date_of_birth': value['date_of_birth'],
    };
}

